import React, { useEffect } from 'react';
import { useTranslator } from 'tradera/lang/translate';
import GoogleTagManager from '../../services/google-tag-manager';

export const KountBlockedMessage = () => {
    const { t } = useTranslator();
    useEffect(() => {
        if (!window.ka) {
            GoogleTagManager.trackEvent({
                category: 'Login and Signup',
                action: 'Kount blocked'
            });
        }
    }, []);

    if (window.ka) return null;

    return (
        <div className="alert alert-info mt-1">
            <p className="mb-0">
                <em>{t('registration_ad_blocker_message')}</em>
            </p>
        </div>
    );
};
